import last from 'lodash/last';
import first from 'lodash/first';

export const getDomainName = () => window.location.hostname;

export const getBaseName = (url: string) => last(url.split('/'));

export const getPdfFilename = (uploadUrl: string) =>
  first(uploadUrl.split('?'));
